<div class="search-bar-container">
  <div class="search-filter-row">
    <div class="search-bar">
      <img src="assets/images/package/search.svg" alt="Search" />
      <input
        class="form-control"
        type="text"
        placeholder="Search for customers.."
        [(ngModel)]="searchText"
        (input)="onSearchInput($event)"
        (keyup.enter)="onSearchInput($event)"
      />
      <button *ngIf="searchText" class="clear-search" (click)="clearSearch()" type="button">
        ×
      </button>
    </div>
  </div>
</div>
<div class="customer-table-container">
  <ng-container *ngIf="!loading; else tableSkeleton">
    <div class="customer-table-scroll" *ngIf="customers.length > 0">
      <table mat-table [dataSource]="dataSource" matSort class="mat-mdc-table customer-table">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="name" class="name-column">
            <span class="p5">Name</span>
          </th>
          <td mat-cell *matCellDef="let customer" class="name-cell">
            <div class="name-content">
              <div class="avatar" (click)="onCustomerNameClick(customer)">
                {{ customer.initials }}
              </div>
              <span class="customer-name clickable p5" (click)="onCustomerNameClick(customer)">
                {{ customer.name }}
              </span>
            </div>
          </td>
        </ng-container>

        <!-- Tags Column -->
        <ng-container matColumnDef="tags">
          <th mat-header-cell *matHeaderCellDef class="tags-column">
            <span class="p5">Tags</span>
          </th>
          <td mat-cell *matCellDef="let customer" class="tags-cell">
            <span
              *ngFor="let tag of tagsOf(customer)"
              class="customer-tag"
              [ngClass]="tag.kind"
              data-testid="customer-tag"
            >
              {{ tag.label }}
            </span>
          </td>
        </ng-container>

        <!-- Vehicles Column -->
        <ng-container matColumnDef="vehicles">
          <th mat-header-cell *matHeaderCellDef class="vehicles-column">
            <div class="header-content">
              <span class="p5">Vehicles</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let customer" class="vehicles-cell">
            <span class="vehicle-text">{{
              customer.vehicles === 'UNKNOWN' ? 'N/A' : customer.vehicles
            }}</span>
          </td>
        </ng-container>

        <!-- License Plate Column -->
        <ng-container matColumnDef="license">
          <th mat-header-cell *matHeaderCellDef class="license-column">
            <div class="header-content">
              <span class="p5">License Plate</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let customer" class="license-cell">
            <span class="license-text">{{ customer.licensePlates }}</span>
          </td>
        </ng-container>

        <!-- Number of Visits Column -->
        <ng-container matColumnDef="visits">
          <th mat-header-cell *matHeaderCellDef class="visits-column">
            <div class="header-content">
              <span class="p5">Number of Visits</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let customer" class="visits-cell">
            <span class="visits-text">{{ customer.numberOfVisits }}</span>
          </td>
        </ng-container>

        <!-- Revenue Column -->
        <ng-container matColumnDef="revenue">
          <th mat-header-cell *matHeaderCellDef class="revenue-column">
            <div class="header-content">
              <span class="p5">Revenue</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let customer" class="revenue-cell">
            <span class="revenue-text">{{ customer.revenue }}</span>
          </td>
        </ng-container>

        <!-- Total Discount Redeemed Column -->
        <ng-container matColumnDef="totalDiscountRedeemed">
          <th mat-header-cell *matHeaderCellDef class="total-discount-column">
            <div class="header-content">
              <span class="p5">Total Discount Redeemed</span>
            </div>
          </th>
          <td mat-cell *matCellDef="let customer" class="total-discount-cell">
            <span class="total-discount-text">{{ customer.totalDiscountRedeemed }}</span>
          </td>
        </ng-container>

        <!-- Last Visit Column -->
        <ng-container matColumnDef="lastVisit">
          <th mat-header-cell *matHeaderCellDef class="last-visit-column">
            <div class="header-content">
              <span class="p5">Last Visit</span>
              <button
                type="button"
                class="filter-icon"
                [class.filter-active]="hasLastVisitFilterValues"
                [matMenuTriggerFor]="lastVisitMenu"
                #lastVisitTrigger="matMenuTrigger"
                (click)="$event.stopPropagation()"
                aria-label="Filter by last visit"
              >
                <img src="assets/images/table/tabler_filter.svg" alt="" />
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let customer" class="last-visit-cell">
            <span class="date-text">{{ customer.lastVisit }}</span>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="status-column">
            <div class="header-content">
              <span class="p5">Status</span>
              <button
                type="button"
                class="filter-icon"
                [class.filter-active]="hasStatusFilterValues"
                [matMenuTriggerFor]="statusMenu"
                #statusTrigger="matMenuTrigger"
                (click)="$event.stopPropagation()"
                aria-label="Filter by status"
              >
                <img src="assets/images/table/tabler_filter.svg" alt="" />
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let customer" class="status-cell">
            <span class="status-tag" [ngClass]="getStatusClass(customer.customer_status)">
              {{ customer.customer_status | titlecase }}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </ng-container>

  <!-- Pagination -->
  <app-pagination-bar
    class="table-pagination"
    *ngIf="totalRecords > 0"
    [paginationData]="paginationData"
    [itemsPerPageOptions]="[5, 10, 20]"
    (pageChange)="onPageChange($event)"
    (itemsPerPageChange)="onRowsPerPageChange($event)"
  >
  </app-pagination-bar>
</div>

<div class="empty-state-container orginal-customer" *ngIf="!loading && customers.length === 0">
  <div class="empty-state-content">
    <div class="empty-state-illustration">
      <img [src]="emptyStateConfig.image" [alt]="emptyStateConfig.title + ' illustration'" />
    </div>
    <div class="empty-state-text">
      <h3 class="empty-state-title">{{ emptyStateConfig.title }}</h3>
      <p class="empty-state-description">{{ emptyStateConfig.description }}</p>
      <button
        class="btn btn-tertiary btn-large"
        *ngIf="hasActiveSearchOrFilters"
        (click)="clearAllFilters()"
      >
        Clear Filters
      </button>
      <button
        class="btn btn-primary btn-medium"
        *ngIf="!hasActiveSearchOrFilters"
        (click)="onAddCustomerClick()"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.58333 0.75V12.4167M0.75 6.58333H12.4167"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Add Customer
      </button>
    </div>
  </div>
</div>

<ng-template #tableSkeleton>
  <div class="table-skeleton">
    <div class="table-skeleton-header">
      <div class="th name"><span class="p5">Name</span></div>
      <div class="th type"><span class="p5">Customer Type</span></div>
      <div class="th plan"><span class="p5">Plan</span></div>
      <div class="th vehicles"><span class="p5">Vehicles</span></div>
      <div class="th license"><span class="p5">License Plate</span></div>
      <div class="th visits"><span class="p5">Number of Visits</span></div>
      <div class="th revenue"><span class="p5">Revenue</span></div>
      <div class="th total-discount"><span class="p5">Total Discount Redeemed</span></div>
      <div class="th last-visit"><span class="p5">Last Visit</span></div>
      <div class="th status"><span class="p5">Status</span></div>
    </div>
    <div class="table-skeleton-body">
      <div class="tr" *ngFor="let _ of skeletonRows; trackBy: trackBySkeletonId">
        <div class="td name">
          <div class="name-content">
            <div class="shimmer-circle"></div>
            <div class="shimmer-line w-120"></div>
          </div>
        </div>
        <div class="td type"><div class="shimmer-pill w-80"></div></div>
        <div class="td plan"><div class="shimmer-pill w-70"></div></div>
        <div class="td vehicles"><div class="shimmer-line w-100"></div></div>
        <div class="td license"><div class="shimmer-line w-90"></div></div>
        <div class="td visits"><div class="shimmer-line w-60"></div></div>
        <div class="td revenue"><div class="shimmer-line w-70"></div></div>
        <div class="td total-discount"><div class="shimmer-line w-70"></div></div>
        <div class="td last-visit"><div class="shimmer-line w-80"></div></div>
        <div class="td status"><div class="shimmer-pill w-70"></div></div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Status Filter Menu -->
<mat-menu #statusMenu="matMenu" panelClass="customer-filter-menu" xPosition="before">
  <div class="status-filter-content" (click)="$event.stopPropagation()">
    <div class="filter-options">
      <div *ngFor="let option of statusOptions; trackBy: trackByValue" class="p-field-checkbox">
        <mat-checkbox
          [checked]="isStatusSelected(option.value)"
          (change)="onStatusToggle(option.value, $event.checked)"
        >
          <span class="p5">{{ option.label }}</span>
        </mat-checkbox>
      </div>
    </div>
    <div class="filter-actions">
      <button
        type="button"
        class="btn btn-tertiary"
        [disabled]="!hasStatusFilterValues"
        (click)="clearStatusFilter()"
      >
        Clear
      </button>
      <div class="right-buttons">
        <button
          type="button"
          class="btn btn-secondary btn-small"
          (click)="statusTrigger.closeMenu()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary btn-small"
          [disabled]="!hasStatusFilterValues"
          (click)="applyStatusFilter()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</mat-menu>
<!-- Last Visit Filter Menu -->
<mat-menu
  #lastVisitMenu="matMenu"
  panelClass="customer-filter-menu last-visit-filter-menu"
  xPosition="before"
>
  <div class="last-visit-filter-content" (click)="$event.stopPropagation()">
    <div class="filter-options">
      <mat-radio-group [(ngModel)]="selectedLastVisitFilter">
        <div
          *ngFor="let option of lastVisitOptions; trackBy: trackByValue"
          class="p-field-radiobutton"
        >
          <mat-radio-button [value]="option.value">
            <span class="p5">{{ option.label }}</span>
          </mat-radio-button>
        </div>
      </mat-radio-group>

      <div *ngIf="isCustomDateRange" class="custom-date-range">
        <div class="date-inputs">
          <mat-form-field appearance="outline" class="date-input-group">
            <mat-label>Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="startPicker"
              [(ngModel)]="customStartDate"
              (ngModelChange)="onCustomStartDateChange($event)"
            />
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" class="date-input-group">
            <mat-label>End Date</mat-label>
            <input
              matInput
              [matDatepicker]="endPicker"
              [(ngModel)]="customEndDate"
              (ngModelChange)="onCustomEndDateChange($event)"
            />
            <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <p class="date-range-error" *ngIf="lastVisitDateRangeError">
          {{ lastVisitDateRangeError }}
        </p>
      </div>
    </div>

    <div class="filter-actions">
      <button
        type="button"
        class="btn btn-tertiary"
        [disabled]="!hasLastVisitFilterValues"
        (click)="clearLastVisitFilter()"
      >
        Clear
      </button>
      <div class="right-buttons">
        <button
          type="button"
          class="btn btn-secondary btn-small"
          (click)="lastVisitTrigger.closeMenu()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary btn-small"
          [disabled]="!canApplyLastVisitFilter"
          (click)="applyLastVisitFilter()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</mat-menu>

<!-- Customer Details Modal -->
<app-customer-details-modal
  [customer]="selectedCustomer"
  [isVisible]="showCustomerModal"
  (close)="onCloseModal()"
  (statusUpdated)="onCustomerStatusUpdated()"
  (customerUpdated)="onCustomerUpdated()"
  (openCustomer)="onOpenCustomerById($event)"
>
</app-customer-details-modal>

<!-- Filter Modal (Customers with Discounts multi-select) -->
